import React from 'react'

class PropertyLabel extends React.Component {
  render() {
    const { name, value, textcolor, ml, checkbox } = this.props;
    const isLight = textcolor === 'white' || textcolor === 'light';

    return (
      <div>
        {ml ? (
          <div>
            <h6 className={`text-${textcolor}`}>{name}:</h6>
            <p className={`${textcolor === null ? 'text-muted' : ''} text-break text-${textcolor}`}>{value}</p>
          </div>
        ) : (
          <div className="od-prop-row" style={isLight ? { borderBottomColor: 'rgba(255,255,255,0.15)' } : undefined}>
            <span className="od-prop-k" style={isLight ? { color: 'rgba(255,255,255,0.7)' } : undefined}>{name}</span>
            {checkbox ? (
              <input type="checkbox" checked={value} disabled="true" />
            ) : (
              <span className="od-prop-v" style={isLight ? { color: '#fff' } : undefined}>{value}</span>
            )}
          </div>
        )}
      </div>
    )
  }
}

export default PropertyLabel

